module.exports = __webpack_public_path__ + "552bc796a52dd436cde5f1fbad9e626e.png";